export default {
  API_ENDPOINT: 'https://app-backend.ease-x.com',
  WS_ENDPOINT: 'wss://app-backend.ease-x.com',
  MAPBOX_TOKEN: 'pk.eyJ1IjoiZWFzZS14IiwiYSI6ImNrbzd5c3FxejBiN2Qydmxremx0ZXVkYmYifQ.LRmzR0UK3ayopjNGewctig',
  GTM_ENABLED: 'true'
}
